import { api } from './api/client';
import { renderLogin, renderSignup } from './components/Auth';
import { renderDomainList } from './components/DomainList';
import { renderPortfolio } from './components/Portfolio';
import { renderSellPages } from './components/SellPages';

type Route = 'login' | 'signup' | 'domains' | 'portfolio' | 'sell';

class App {
  private currentRoute: Route = 'login';

  constructor() {
    this.init();
  }

  private init() {
    // Check if user is authenticated
    if (api.isAuthenticated()) {
      this.navigate('domains');
    } else {
      this.navigate('login');
    }

    // Handle navigation
    window.addEventListener('popstate', () => {
      this.handleRoute();
    });
  }

  navigate(route: Route) {
    this.currentRoute = route;
    window.history.pushState({}, '', `/${route === 'domains' ? '' : route}`);
    this.render();
  }

  private handleRoute() {
    const path = window.location.pathname;
    if (path === '/login') {
      this.currentRoute = 'login';
    } else if (path === '/signup') {
      this.currentRoute = 'signup';
    } else if (path === '/sell') {
      this.currentRoute = api.isAuthenticated() ? 'sell' : 'login';
    } else if (path === '/portfolio') {
      this.currentRoute = api.isAuthenticated() ? 'portfolio' : 'login';
    } else {
      this.currentRoute = api.isAuthenticated() ? 'domains' : 'login';
    }
    this.render();
  }

  private render() {
    const content = document.getElementById('content');
    const nav = document.getElementById('nav');

    if (!content || !nav) return;

    // Render navigation
    if (api.isAuthenticated()) {
      nav.innerHTML = `
        <a href="/" id="nav-domains">Marketplace</a>
        <a href="/portfolio" id="nav-portfolio">Portfolio</a>
        <a href="/sell" id="nav-sell">Sell Pages</a>
        <button id="logout-btn" class="btn btn-secondary">Logout</button>
      `;
      document.getElementById('nav-domains')?.addEventListener('click', (e) => {
        e.preventDefault();
        this.navigate('domains');
      });
      document.getElementById('nav-portfolio')?.addEventListener('click', (e) => {
        e.preventDefault();
        this.navigate('portfolio');
      });
      document.getElementById('nav-sell')?.addEventListener('click', (e) => {
        e.preventDefault();
        this.navigate('sell');
      });
      document.getElementById('logout-btn')?.addEventListener('click', () => {
        api.logout();
        this.navigate('login');
      });
    } else {
      nav.innerHTML = `
        <a href="/login" id="nav-login">Login</a>
        <a href="/signup" id="nav-signup">Sign Up</a>
      `;
      document.getElementById('nav-login')?.addEventListener('click', (e) => {
        e.preventDefault();
        this.navigate('login');
      });
      document.getElementById('nav-signup')?.addEventListener('click', (e) => {
        e.preventDefault();
        this.navigate('signup');
      });
    }

    // Render content based on route
    switch (this.currentRoute) {
      case 'login':
        renderLogin(content, () => this.navigate('domains'), () => this.navigate('signup'));
        break;
      case 'signup':
        renderSignup(content, () => this.navigate('domains'), () => this.navigate('login'));
        break;
      case 'domains':
        if (!api.isAuthenticated()) {
          this.navigate('login');
          return;
        }
        renderDomainList(content);
        break;
      case 'portfolio':
        if (!api.isAuthenticated()) {
          this.navigate('login');
          return;
        }
        renderPortfolio(content);
        break;
      case 'sell':
        if (!api.isAuthenticated()) {
          this.navigate('login');
          return;
        }
        renderSellPages(content);
        break;
    }
  }
}

// Start the app
new App();
